export class M3Presentaciones{
    public NIVELPRS:string;
    public VALOR:number;
    public TOPE:number;
}